import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type UserOrderResponseWithFlagsSubOrdersInner } from '@redteclab/api/clients/bully'

import { priceGetFormattedPrice } from '../../../../../price'

export const DirectContactFormOrderSelectionCardSellerAndTotal: FC<{
  subOrder: UserOrderResponseWithFlagsSubOrdersInner
}> = ({ subOrder }) => {
  const intl = useIntl()
  const { sellerName, totalAmount } = subOrder

  return (
    <div className="flex w-full justify-between">
      <p className="flex text-s font-medium">{sellerName}</p>
      {totalAmount === undefined ? null : (
        <p
          className="items-end text-m font-medium"
          data-qa-id="direct-contact-form-order-total-amount"
        >
          {priceGetFormattedPrice(totalAmount, intl)}
        </p>
      )}
    </div>
  )
}
